import React from "react"
import { ButtonProps, IconButtonProps } from "@material-ui/core"
import { StyledIconButton } from "./style"

export type TIconButtonProps = IconButtonProps & { variant?: ButtonProps["variant"] }
const IconButton: React.FC<TIconButtonProps> = props => <StyledIconButton disableRipple={true} {...props} />

export default IconButton
